import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Box, Button, Card, Container, Grid, Stack, Table, TableBody, TableContainer, Typography } from '@mui/material';
// components
import moment from 'moment';
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ButtonAction from 'src/components/Button.js/SaveButton';
import EmtyData from 'src/components/emty-data';
import Iconify from 'src/components/iconify/Iconify';
import ComboBox from 'src/components/Input/ComboBox';
import DatePickerValue from 'src/components/Input/DatePickerValue';
import TextInput from 'src/components/Input/TextInput';
import Loader from 'src/components/loader/loader';
import DepartmentListHead from 'src/sections/@dashboard/department/DepartmentListHead';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import ItemListReviewDevice from './ItemListReviewDevice';
import AdminGetDevice from './modal/AdminGetDevice';
import AdminReviewDevice from './modal/AdminReviewDevice';

// ----------------------------------------------------------------------
const STATUS_COLOR = {
    0: 'info',
    4: 'info',
    8: 'warning',
    9: 'success',
};
export default function ReviewReturnDevice({ device_cd = '' }) {
    // region variables
    const { t } = useTranslation();
    const getRef = useRef();
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const params = useParams();
    const tableRef = useRef(null);
    const lastIdRef = useRef(0);
    const dataRef = useRef(null);
    const [totalData, setTotalData] = useState(0);
    const valueSearch = useRef({
        key: '',
        startDay: moment().subtract(1, 'months').format('YYYYMMDD'),
        endDay: moment().format('YYYYMMDD'),
        status: 'all',
    });
    const handleOnChange = (e, key) => {
        valueSearch.current[key] = e;
    };
    const [visibleOpenAdminGet, setVisibleOpenAdminGet] = useState(false);
    const [visibleOpenAdminReview, setVisibleOpenAdminReview] = useState(false);
    const user = glb_sv.userInfo;
    const isAdmin = user?.group_user === '1' || user?.group_user === '2';
    // region ARR_STATUS
    const ARR_STATUS = [
        { label: t('all'), value: 'all' },
        { label: t('have_refund'), value: '4' },
        { label: t('return'), value: 'igb' },
        { label: t('admin_is_under_review'), value: '8' },
        { label: t('success'), value: '9' },
    ];
    // region TABLE_HEAD
    const TABLE_HEAD = [
        { id: '', label: '', alignRight: false },
        { id: '', label: '#', alignRight: false },
        { id: 'status', label: t('status'), alignRight: false },
        { id: 'device', label: t('device'), alignRight: false },
        { id: 'info', label: t('info'), alignRight: false },
        { id: 'borrower_return', label: t('borrower_return'), alignRight: false },
        { id: 'day_give', label: t('day_give'), alignRight: false },
        { id: 'quantity_category', label: t('quantity_category'), alignRight: false },
        { id: 'qtyRequest', label: t('qtyRequest'), alignRight: false },
        { id: 'qtyInventory', label: t('qtyInventory'), alignRight: false },
        { id: 'noteReturnChange', label: t('noteReturnChange'), alignRight: false },
        { id: 'userRequest', label: t('userRequest'), alignRight: false },
        { id: 'dateRequest', label: t('dateRequest'), alignRight: false },
        { id: 'userApproveOrReject', label: t('userApproveOrReject'), alignRight: false },
        { id: 'dateApproveReject', label: t('dateApproveReject'), alignRight: false },
        { id: 'reason', label: t('reason'), alignRight: false },
        { id: 'note_grinding', label: t('note_grinding'), alignRight: false },
        { id: 'new_place', label: t('new_place'), alignRight: false },
        { id: 'note_', label: t('note_'), alignRight: false },
        { id: 'real_price_transaction', label: t('real_price_transaction'), alignRight: false },
        { id: 'depreciation_rate', label: t('depreciation_rate'), alignRight: false },
        { id: 'price_transaction', label: t('price_transaction'), alignRight: false },
        { id: 'price_after_depreciation', label: t('price_after_depreciation'), alignRight: false },
        { id: 'code_device', label: t('code_device'), alignRight: false },
        { id: 'action', label: '', alignRight: false, stickyEnd: true },
    ];

    // region useEffect getData
    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    // region getData
    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [
            valueSearch.current.status,
            9999999999999,
            valueSearch.current.startDay,
            valueSearch.current.endDay,
            valueSearch.current.key,
        ];
        sendRequest(serviceList.device_not_yet_review, InVal, getDataResult, true, timeOutFunct, 15000);
    }, []);

    // region getDataResult
    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const dataRes = message.proc_data.rows[0]?.o_1 || [];
            if (dataRes?.length) lastIdRef.current = dataRes[dataRes.length - 1].id;
            setTableData(dataRes);
            setTotalData(message.proc_data.rowTotal || 0);
            console.log('dataRes', dataRes);
        }
    };

    // region getDataNext
    const getDataNext = (lastId = lastIdRef.current) => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        setGetFlags(true);
        const InVal = [
            valueSearch.current.status,
            lastId,
            valueSearch.current.startDay,
            valueSearch.current.endDay,
            valueSearch.current.key,
        ];
        sendRequest(serviceList.device_not_yet_review, InVal, getDataNextResult, true, timeOutFunct, 15000);
    };

    // region getDataNextResult
    const getDataNextResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const dataRes = message.proc_data.rows[0]?.o_1 || [];
            if (dataRes?.length) lastIdRef.current = dataRes[dataRes.length - 1].id;
            setTableData([...tableData, ...dataRes]);
            setTotalData(message.proc_data.rowTotal || 0);
            console.log('dataRes', dataRes);
        }
    };

    // region timeOutFunct
    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    // region onDownload Excel
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: t('depreciation_assessment'),
        sheet: t('depreciation_assessment'),
    });

    return (
        <>
            {!device_cd && (
                <Helmet>
                    <title> {t('review_return_device')} </title>
                </Helmet>
            )}

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('review_return_device')}
                    </Typography>{' '}
                    <Button
                        variant="contained"
                        startIcon={<Iconify icon="mingcute:file-export-line" />}
                        onClick={onDownload}
                    >
                        {t('export_excel')}
                    </Button>
                </Stack>{' '}
                {!device_cd && (
                    <Breadcrumb paths={[{ label: t('review_return_device'), url: '#', navigate: false }]} />
                )}
                <Loader loading={getFlags} />
                <Card>
                    <AdminGetDevice
                        idPermission={parseInt(params.idPermission)}
                        visible={visibleOpenAdminGet}
                        setVisible={setVisibleOpenAdminGet}
                        callBackFunct={() => {
                            setVisibleOpenAdminGet(false);
                            getData();
                        }}
                        data={dataRef.current}
                    />
                    <AdminReviewDevice
                        idPermission={parseInt(params.idPermission)}
                        visible={visibleOpenAdminReview}
                        setVisible={setVisibleOpenAdminReview}
                        callBackFunct={() => {
                            setVisibleOpenAdminReview(false);
                            getData();
                        }}
                        data={dataRef.current}
                    />
                    <Grid padding={'20px 10px'} container spacing={1} style={{}}>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <TextInput
                                size="medium"
                                getValue={(e) => handleOnChange(e, 'key')}
                                label={t('searchDevice')}
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%', marginTop: 7 }}>
                            <ComboBox
                                label={t('filter_status')}
                                sizeCbb="medium"
                                displayLabel="label"
                                valueEqual="value"
                                getValue={(e) => handleOnChange((e || {})['value'] || 'all', 'status')}
                                selectOption={ARR_STATUS}
                                required
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue
                                label={t('start_day')}
                                valueChange={valueSearch.current.startDay}
                                getValue={(e) => handleOnChange(e, 'startDay')}
                            />
                        </Grid>
                        <Grid item xl={2.5} md={2.5} sm={12} style={{ width: '100%' }}>
                            <DatePickerValue
                                label={t('to_day')}
                                valueChange={valueSearch.current.toDay}
                                getValue={(e) => handleOnChange(e, 'endDay')}
                            />
                        </Grid>
                        <Grid item xl={2} md={2} sm={12} style={{ width: '100%', marginTop: 9 }}>
                            <ButtonAction
                                fullWidth
                                onClick={getData}
                                size="large"
                                type={'search'}
                                title={t('search')}
                                sx={{ padding: 3.3 }}
                            />
                        </Grid>
                    </Grid>
                    <Stack sx={{ maxHeight: '70vh' }}>
                        <TableContainer>
                            <Table>
                                <DepartmentListHead
                                    order={'asc'}
                                    orderBy={'name'}
                                    headLabel={TABLE_HEAD}
                                    rowCount={tableData.length}
                                />
                                <TableBody>
                                    {tableData.length > 0 &&
                                        tableData.map((item, index) => {
                                            return (
                                                <ItemListReviewDevice
                                                    key={index}
                                                    item={item}
                                                    index={index}
                                                    STATUS_COLOR={STATUS_COLOR}
                                                    isAdmin={isAdmin}
                                                    dataRef={dataRef}
                                                    openButton={true}
                                                    setVisibleOpenAdminGet={setVisibleOpenAdminGet}
                                                    setVisibleOpenAdminReview={setVisibleOpenAdminReview}
                                                />
                                            );
                                        })}
                                </TableBody>
                            </Table>
                            {tableData.length === 0 && <EmtyData />}
                        </TableContainer>
                        <Box
                            sx={{ position: 'sticky', zIndex: 1000, bottom: 0, backgroundColor: '#f1f3f4' }}
                            display={'flex'}
                            justifyContent={'space-between'}
                            alignItems={'center'}
                            paddingLeft={2}
                            // paddingRight={2}
                        >
                            <Stack>
                                <span>
                                    {t('total_row')}: {tableData.length}/{totalData}
                                </span>
                            </Stack>
                            <Button
                                variant="contained"
                                endIcon={<Iconify icon="material-symbols:skip-next-rounded" />}
                                onClick={() => getDataNext()}
                                disabled={tableData.length < totalData ? false : true}
                            >
                                {t('next')}
                            </Button>
                        </Box>
                    </Stack>
                    {/* table xuất excel */}
                    <TableContainer>
                        <Table ref={tableRef} sx={{ display: 'none' }}>
                            <DepartmentListHead
                                order={'asc'}
                                orderBy={'name'}
                                headLabel={TABLE_HEAD}
                                rowCount={tableData.length}
                            />
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => {
                                        return (
                                            <ItemListReviewDevice
                                                key={index}
                                                item={item}
                                                index={index}
                                                STATUS_COLOR={STATUS_COLOR}
                                                isAdmin={isAdmin}
                                                dataRef={dataRef}
                                                openButton={false}
                                            />
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Card>
            </Container>
        </>
    );
}
